<p-toast></p-toast>
<p-overlayPanel #op [dismissable]="true" appendTo="body" styleClass="clearfix">
  <div class="form-group cleafix">
    <input
      class="form-control"
      pInputText
      type="text"
      name="name"
      placeholder="Nome"
      [(ngModel)]="service.search.like.name"
    />
  </div>

  <div class="form-group cleafix">
    <p-autoComplete
      [(ngModel)]="selectedCategory"
      [suggestions]="categoryItems"
      (completeMethod)="filterCategory($event)"
      field="name"
      placeholder="Categoria..."
      (onSelect)="fillCategory()"
      (onClear)="clearCategory()"
      [style]="{ width: '100%' }"
      [dropdown]="true"
    ></p-autoComplete>
  </div>

  <div class="form-group cleafix" style="display: flex; justify-content: space-between;">
    <label>Archiviato</label>
    <p-inputSwitch
      (onChange)="onFilterArchived($event)"
      [ngModel]="archivedFilter"
      inputStyleClass="form-control"
    ></p-inputSwitch>
  </div>

  <div class="form-group cleafix">
    <div class="row">
      <div class="col-sm-6">
        <button type="button" class="btn btn-success btn-block" (click)="reload(table); op.hide()">
          Cerca
        </button>
      </div>
      <div class="col-sm-6">
        <button
          type="button"
          class="btn btn-default btn-block"
          (click)="archivedFilter = false; reset(table); clearCategory(); op.hide()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</p-overlayPanel>

<div class="main-content clearfix">
  <div class="list-wrapper clearfix">
    <div class="content clearfix">
      <div class="row">
        <div class="col-sm-8">
          <h4>
            <i class="fa fa fa-book"></i>
            Tipologie
          </h4>
        </div>
        <div class="col-sm-4">
          <button class="btn btn-add pull-right" type="button" (click)="new()" label="">
            <i class="fa fa-plus-circle" aria-hidden="true"></i>
            Aggiungi
          </button>
        </div>
      </div>
      <div class="clearfix"></div>
      <br />
      <div class="clearfix"></div>
      <div class="filter-wrapper clearfix">
        <button
          type="text"
          class="btn btn-filter"
          label="Basic"
          appendTo="body"
          (click)="op.toggle($event)"
        >
          <i class="fa fa-sliders" aria-hidden="true"></i>
          Cerca
        </button>

        <div class="tags-wrapper">
          <div class="tag-item" *ngIf="service.search.like.name">
            <strong>nome:</strong>
            {{ service.search.like.name }}
            <button (click)="service.search.like.name = null; reload(table)" class="btn-close">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>

          <div class="tag-item" *ngIf="service.search.obj.category_uuid">
            <strong>categoria:</strong>
            {{ selectedCategory?.name }}
            <button (click)="clearCategory(); reload(table)" class="btn-close">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>

          <div class="tag-item" *ngIf="archivedFilter">
            <strong>archiviato:</strong>
            {{ archivedFilter ? 'Si' : 'No' }}
            <button
              (click)="archivedFilter = false; service.search.obj.active = null; reload(table)"
              class="btn-close"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-body list">
          <div class="row">
            <p-table
              [value]="model"
              [loading]="loading"
              [lazy]="true"
              (onLazyLoad)="lazyLoad($event)"
              [paginator]="true"
              [responsive]="true"
              [rows]="service.search.pageSize"
              [totalRecords]="service.listSize"
              [resizableColumns]="true"
              stateStorage="session"
              [stateKey]="path + '_table'"
              #table
            >
              <ng-template pTemplate="header" let-columns class="search-filter">
                <tr class="sort-header">
                  <th class="RowIndex"></th>
                  <th pResizableColumn [pSortableColumn]="'name'">
                    Nome
                    <p-sortIcon [field]="'name'"></p-sortIcon>
                  </th>
                  <th pResizableColumn [pSortableColumn]="'category_uuid'">
                    Categoria
                    <p-sortIcon [field]="'category_uuid'"></p-sortIcon>
                  </th>
                  <th pResizableColumn>Templates</th>
                  <th pResizableColumn [pSortableColumn]="'active'">
                    Archiviata
                    <p-sortIcon [field]="'active'"></p-sortIcon>
                  </th>
                  <th class="Operations"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="colspan">Nessun risultato.</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                <tr>
                  <td class="RowIndex">{{ rowIndex + 1 }}</td>
                  <td class="ui-resizable-column">
                    {{ rowData.name }}
                  </td>
                  <td class="ui-resizable-column">
                    {{ rowData.category_name }}
                  </td>
                  <td class="ui-resizable-column">
                    <span *ngFor="let template of rowData.templates; let i = index">
                      {{
                        i !== rowData.templates.length - 1
                          ? (template.name | addTrailComma)
                          : template.name
                      }}
                    </span>
                  </td>
                  <td class="ui-resizable-column">
                    <i class="fa fa-{{ !rowData.active ? 'check' : 'times' }}"></i>
                  </td>
                  <td>
                    <div class="btn-group">
                      <button
                        type="button"
                        pButton
                        (click)="edit(rowData)"
                        class="btn btn-success btn-sm"
                        pTooltip="Modifica"
                        tooltipPosition="top"
                        icon="fa fa-edit"
                      ></button>
                      <button
                        type="button"
                        pButton
                        (click)="view(rowData)"
                        class="btn btn-info btn-sm"
                        pTooltip="Visualizza"
                        tooltipPosition="top"
                        icon="fa fa-eye"
                      ></button>
                      <button
                        type="button"
                        pButton
                        pTooltip="Clona"
                        tooltipPosition="top"
                        (click)="clone(rowData)"
                        class="btn btn-default btn-sm"
                        icon="fa fa-clone"
                      ></button>
                      <button
                        type="button"
                        pButton
                        (click)="exportTemplate(rowData)"
                        class="btn btn-primary btn-sm"
                        pTooltip="Esporta Template"
                        tooltipPosition="left"
                        icon="fa fa-print"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
